"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HASH_PREFIX_NODE_DICT = exports.HASH_PREFIX_NODE_ARRAY = exports.HASH_PREFIX_LEAF = exports.HASH_PREFIX_NODE = void 0;
exports.HASH_PREFIX_NODE = 0;
exports.HASH_PREFIX_LEAF = 1;
exports.HASH_PREFIX_NODE_ARRAY = 7;
exports.HASH_PREFIX_NODE_DICT = 8;
//# sourceMappingURL=constants.js.map